/**
 * Test IDs for the Dashboard page and all its sub-components.
 *
 * Naming convention:  {page}-{section}-{element}-{qualifier?}
 * All IDs are kebab-case and stable — do NOT use display labels or i18n strings.
 *
 * Usage:
 *   import { DASHBOARD_TEST_IDS as TID } from "@/constant/testIds/dashboard.testIds";
 *   <div data-testid={TID.PAGE} />
 */

export const DASHBOARD_TEST_IDS = {
  // ── Page shell ────────────────────────────────────────────────────────────
  PAGE: 'dashboard-page',

  // ── Stat cards ────────────────────────────────────────────────────────────
  STAT_SMART_COOLER_PRODUCTS: 'dashboard-stat-smart-cooler-products',
  STAT_VDI_TRANSACTIONS: 'dashboard-stat-vdi-transactions',
  STAT_OPERATORS: 'dashboard-stat-operators',
  STAT_PROVIDERS: 'dashboard-stat-providers',

  // ── Charts ────────────────────────────────────────────────────────────────
  HERO_CHART: 'dashboard-hero-chart',
  ALERTS_CHART: 'dashboard-chart-alerts',
  DATE_LABEL: 'dashboard-date-label',
  /** Dynamic per-type charts (e.g. "vdi", "cooler") */
  CHART: (key: string) => `dashboard-chart-${key}`,

  // ── Recent alerts section ─────────────────────────────────────────────────
  RECENT_ALERTS_SECTION: 'dashboard-recent-alerts',
  /** Each alert row, keyed by alertId */
  ALERT_ROW: (alertId: string | number) => `dashboard-alert-row-${alertId}`,
} as const;
